import React from "react";

const TotalNumberCell = (key) => {
  return (totals) => (
    <div>
      {totals[key]}
    </div>
  );
};

export { TotalNumberCell };
